// @flow
import React from "react";
import { OfferSummary, Section } from "buba-components";
import { formatCurrency } from "buba-components/src/utils/formatters";
import type { GuaranteeDecision } from "../../../data/guaranteeInterestOptions";

type SummaryProps = {
  federalState: string,
  contactPerson: string,
  phoneNumber: string,
  company: string,
  amount: string,
  numberOfBanks: number,
  shouldHideIncludingYours?: boolean,
  status: string,
  decision: GuaranteeDecision,
  guaranteeInterest: string,
  products: Array<string>,
  creator: "bankAdvisor" | "customer"
};

const Summary = ({
  federalState,
  contactPerson,
  phoneNumber,
  company,
  amount,
  numberOfBanks,
  shouldHideIncludingYours = false,
  status,
  decision,
  guaranteeInterest,
  products,
  creator
}: SummaryProps) => (
  <Section title="Zusammenfassung" numbered reducedMargin>
    <OfferSummary
      federalState={federalState}
      contactPerson={contactPerson}
      phoneNumber={phoneNumber}
      company={company}
      amount={amount}
      numberOfBanks={numberOfBanks}
      shouldHideIncludingYours={shouldHideIncludingYours}
      status={status}
      decision={decision}
      guaranteeInterest={guaranteeInterest}
      products={products}
      creator={creator}
      currencyFormatter={formatCurrency}
    />
  </Section>
);

export default Summary;
